import React, { Component } from "react";
import {redirectToIESLogin} from  "../service/auth_service_ies.js"

class NewLogin extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoading: true,
    }
  }

  componentDidMount() {
    redirectToIESLogin();
  }

  render() {
    return (
      <div className=" anonymous  login ">
        <div
          className="container-fluid background-image d-flex justify-content-center align-items-center"
          id="wizme_app"
        >
          <div className="container" style={{'color': '#113057'}}>
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                <div className="spinner-border home-loading" role="status"></div>
              </div>
              <div className="col-12 text-center">
                <div style={{ color: 'rgb(117,117,117)' }}>
                  Estamos fazendo login automático, aguarde...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default NewLogin;
